import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLoginToken } from '../../Store/loginTokenSlice'; // Ensure the path is correct
import classes from '../../style/HomeScreen.module.css';
import "../../style/Welcomescreens.scss";
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTE_RESIDENTIAL_STATUS } from '../../Routes';
import NewDexterLogo from '../../Images/NewDexterLogo.svg';

const FourSplash = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Select the token from the Redux store
  const token = useSelector((state) => state.loginToken.value); // Updated selector
  console.log(token)

  useEffect(() => {
    if (location.state?.tokens) {
      console.log('Dispatching token:', location.state.tokens);
      dispatch(setLoginToken(location.state.tokens)); // Updated dispatch
    }
  }, [location.state, dispatch]);

  useEffect(() => {
    console.log('Token received from Redux store:', token);
  }, [token]);

  const handleSubmit = () => {
    navigate(ROUTE_RESIDENTIAL_STATUS);
  };

  return (
    <div className="Splash4Main_Container">
      <header className="Splash4Header">
        <img alt="" src={NewDexterLogo} className="DexterLogo" />
      </header>
      <div className="Internal_Main_Container4">
        <p className="Splash4SubHeading">
          Help Dexter<br />
          <span className="FourSplash_Highlighted_text">understand</span>
          you a little better?
        </p>
        <div className="Spash4_Button_Container">
          <button className="Proceed_button" onClick={handleSubmit}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default FourSplash;
